module.exports = __webpack_public_path__ + "static/primary-blue-7c13e697189eb8b6cb31fd09b83d551d.png";